import { render, staticRenderFns } from "./OpportunityHome.vue?vue&type=template&id=c0ee508c&scoped=true&"
import script from "./OpportunityHome.vue?vue&type=script&lang=ts&"
export * from "./OpportunityHome.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0ee508c",
  null
  
)

export default component.exports